export abstract class _baseService {

	protected constructor() {
	}

}
